import { css } from 'styled-components';
export default css(["display:inline-block;vertical-align:middle;max-width:100%;height:auto;border-style:none;"]);